import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Promise() {
  return <section className="py-20 px-6 bg-rotterdam-dark" data-id="element-197">
      <div className="max-w-4xl mx-auto" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="border-2 border-rotterdam-gold pearl-border rounded-2xl px-8 py-12 md:px-14 md:py-16 text-center" data-id="element-199">
          <ShieldCheck className="w-16 h-16 mx-auto mb-6 text-rotterdam-gold pearl-icon" data-id="element-200" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-rotterdam-gold pearl-text" data-id="element-201">
            Nuestra Promesa
          </h2>
          <p className="text-lg md:text-xl font-medium leading-relaxed text-rotterdam-cream/90" data-id="element-202">
            En Rotterdam nos comprometemos a entregar un corte prolijo,
            equilibrado y acorde a tu estilo. Si algo no cumple con tus
            expectativas dentro de las 72 hs posteriores al servicio (nuca,
            patillas, contornos o fade), te ofrecemos un retoque sin cargo.
          </p>
        </motion.div>
      </div>
    </section>;
}